interface LogWithAdmin {
  superadmin?: { id: string; name: string } | null;
}

/** Sentinel administrator id standing in for System (null-`superadmin`) log entries. */
export const SYSTEM_ADMINISTRATOR = '__system__';

/** Org logs written by the system (no administrator) have a null `superadmin`. */
export const logAdminName = (log: LogWithAdmin): string => log.superadmin?.name ?? 'System';

export const uniqueLogAdmins = (logs: LogWithAdmin[]): Array<{ value: string; label: string }> => {
  const admins = logs.flatMap((log) => (log.superadmin ? [{ value: log.superadmin.id, label: log.superadmin.name }] : []));
  return admins.filter((item, idx) => admins.findIndex((i) => i.value === item.value) === idx);
};

/**
 * `all` keeps every log (System ones included); otherwise only logs of the selected administrators
 * match, and `SYSTEM_ADMINISTRATOR` in the selection lets System (null-`superadmin`) entries match too.
 */
export const filterLogsByAdmin = <T extends LogWithAdmin>(logs: T[], admins: string[]): T[] => {
  if (admins.includes('all')) return logs;
  return logs.filter((log) => (
    log.superadmin ? admins.includes(log.superadmin.id) : admins.includes(SYSTEM_ADMINISTRATOR)
  ));
};
